{
  "Timezone_Title_Change": "Change User Timezone",
  "Timezone_Title_Update": "Update User Timezone",
  "Timezone_Dropdown_Title": "Timezone",
  "Timezone_Tab_General": "General",
  "Timeline_Prompt_Change": "Change",
  "Timeline_Prompt_Cancel": "Cancel",
  "Timeline_Prompt_Change_Message": "We have have detected a change to your user Timezone\n\nIt was originally **{}**\n\nWould you like to change your local Timezone to **{}**",
  "Timeline_Prompt_First_Time_Message": "Your current reporting Timezone is set to **{}**\n\nWould you like to update your reports to your local Timezone **{}**",
  "NAME": "TimezoneModal"
}